import type { ISetPasswordDto } from "./types";
import type { IPathBaseParam } from "./path";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  ISetPasswordDto
>("auth.passwordReset.setPassword");

export const setPassword = {
  ...postApis,
};
